import React, { memo, useMemo } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'slices/glassDashboard/glassDataModalSlice';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import ExportButton from 'components/common/advance-table/ExportButton';
import './modal.css';

const GlassDataModal = () => {
    const dispatch = useDispatch();
    const { modalData, tableCols, modalLoading, modalShow, modalTitle } = useSelector(s => s.glassDataModal);

    const tableProps = useMemo(() => ({
        bordered: true,
        striped: true,
        className: 'fs--1 mb-0',
        responsive: true
    }), []);

    return (
        <Modal show={modalShow} centered scrollable dialogClassName="glass-data-modal" onHide={() => dispatch(closeModal())} >
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <AdvanceTableWrapper
                        columns={tableCols}
                        data={modalData}
                        sortable
                        perPage={1000}
                        pagination={1000}
                    >
                        <Row className="d-flex justify-content-between mb-3">
                            <Col>
                                <ExportButton table />
                            </Col>
                            <Col xs="auto">
                                <AdvanceTableSearchBox table />
                            </Col>
                        </Row>
                        <div className="sticky-zone-stillages">
                            <AdvanceTable
                                table
                                headerClassName="bg-200 text-nowrap align-middle sticky-header-stillages"
                                rowClassName="align-middle white-space-nowrap"
                                tableProps={tableProps}
                                loading={modalLoading}
                                handleClickRow={() => null}
                            />
                        </div>
                    </AdvanceTableWrapper>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

export default memo(GlassDataModal);